import React, { useState, useEffect, useCallback } from 'react';
import { Table } from '@b-design/fusion';
import { appMemberColumns, renderActionItem } from './const.js';
import Requests from '@/services/request';
import $i18n from '@/i18n';
import Space from '@/components/Space';
import { history } from 'ice';
import PaginationComponent from '@/components/PaginationComponent';
import { queryStringify, getQueryStringArgs } from '@/utils/url-parse';
// import './index.less';
// import Spining from '@/components/Spining';

interface Pending {
  contentHeight: number;
}

const Pending: React.FC<Pending> = ({ contentHeight }) => {
  const { spaceId } = getQueryStringArgs();
  const [column, setColumns] = useState<any[]>(appMemberColumns(spaceId));
  const [dataSource, setDataSource] = useState({ list: [], total: 0 });
  const [loading, setLoading] = useState(false);
  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });

  // 获取审批列表
  const changeRouter = (record) => {
    history?.push(
      `/approvals/detail?${queryStringify({
        spaceId,
        approveId: record.approveId,
        defaultActiveKey: 'Pending',
      })}`,
    );
  };

  useEffect(() => {
    const actionRender = {
      title: $i18n.get({ id: 'aopf.pages.member.columnsAction', dm: '操作' }),
      dataIndex: 'action',
      width: 90,
      // lock: true,
      cell: (value, index, record) => (
        <Space style={{ color: 'var(--superapp-primary-1)' }}>
          <div onClick={() => changeRouter(record)}>
            {renderActionItem({
              icon: 'view--outline',
              content: $i18n.get({
                id: 'aopf.pages.approvals.columnsActionView',
                dm: '查看',
              }),
              // i18nId: 'aopf.pages.approvals.columnsActionView',
              // dm: '查看',
            })}
          </div>
        </Space>
      ),
    };
    setColumns([...appMemberColumns(spaceId), actionRender]);
    // 查询审批列表
    // Requests.get('/rest/intercnn/approve/query',{currentPage: 1,pageSize: 10,status:"PEND" }).then((res)=>{
    //   if(res){
    //     const { list = [], total } = res;
    //     setDataSource({ list, total });
    //   }

    // });
  }, []);

  const queryPending = useCallback(
    (params = { status: 'PROCESSING', currentPage: 1, pageSize: 10, approveTarget: spaceId }) => {
      setLoading(true);
      Requests.get('/rest/intercnn/approve/query', { ...params }).then((data) => {
        if (data) {
          const { list = [], total } = data;
          setDataSource({ list: list, total: total });
          setLoading(false);
        }
      }).catch(() => {
        setLoading(false);
      });
    },
    [spaceId],
  );

  useEffect(() => {
    if (!spaceId) {
      return;
    }
    queryPending({ status: 'PROCESSING', ...paginationValue, approveTarget: spaceId });
  }, [paginationValue, queryPending, spaceId]);

  return (
    <div className="list-content">
      {/* {loading && <Spining />} */}
      <Table.StickyLock
        columns={column}
        fixedHeader
        maxBodyHeight={contentHeight - 48}
        loading={loading}
        dataSource={dataSource?.list}
        rowkey="approveId"
      />
      <div className="pagenation-container">
        <PaginationComponent
          total={dataSource?.total}
          current={paginationValue?.currentPage}
          pageSize={paginationValue?.pageSize}
          onPageChange={(current, pageSize) => {
            setPaginationValue({
              currentPage: current,
              pageSize,
            });
          }}
        />
      </div>
    </div>
  );
};
export default Pending;
